import { BaseModel } from '@/modules/core/app/models/abstracts/BaseModel';
import { WorkerManagerDefaultOptions } from '@/modules/core/app/constants/workermanager.constants';

export class WorkerManagerOptions extends BaseModel {
  /**
   * @var
   */
  event;

  /**
   * @var
   */
  statusUrl;

  /**
   * @var
   */
  pollTimeout;

  /**
   * @var
   */
  maxPollCount;

  constructor(model = {}) {
    super(model);
    this.event = model.event || WorkerManagerDefaultOptions.JOB_COMPLETION;
    this.statusUrl = model.statusUrl || WorkerManagerDefaultOptions.STATUS_URL;
    this.pollTimeout = model.pollTimeout || WorkerManagerDefaultOptions.POLL_INTERVAL;
    this.maxPollCount = model.maxPollCount || WorkerManagerDefaultOptions.MAX_POLL_COUNT;
  }
}
